import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinindapur() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Indapur',
        heading: 'Urbania on rent in pune: Urbania On Rent in Indapur',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Indapur for corporate groups, families, tourists, and event travelers planning trips to and from Indapur. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Indapur. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Indapur.',

        top: 'Top Places to Visit in Indapur with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Bhima River Ghat",
    "description": "The Bhima River Ghat is one of the most peaceful and scenic spots around Indapur, offering beautiful views of flowing water, open skies, and rural landscapes. Locals visit the ghat for morning walks, evening relaxation, religious rituals, and festivals like Chhath Puja. During monsoon and post-monsoon seasons, the riverbanks turn lush green, making it a calm retreat for nature lovers and photographers seeking a serene countryside atmosphere."
  },
  {
    "title": "Ujani Dam (Bhima Backwaters)",
    "description": "Ujani Dam, built on the Bhima River, is a major attraction near Indapur and an important lifeline for irrigation in the region. The vast backwaters create stunning views, especially during monsoon and winter when water levels are high. The area attracts bird watchers, photographers, and travelers looking for wide-open landscapes, cool breezes, and peaceful sunset views over the reservoir."
  },
  {
    "title": "Shri Khandoba Temple, Indapur",
    "description": "The Khandoba Temple in Indapur is a significant religious site dedicated to Lord Khandoba, widely worshipped in Maharashtra. Devotees visit the temple throughout the year, especially during Champa Shashthi and other traditional festivals. The temple’s spiritual atmosphere, local rituals, and strong cultural roots make it an important landmark reflecting the faith and traditions of the region."
  },
  {
    "title": "Local Jain Temples",
    "description": "Indapur is home to several Jain temples known for their peaceful ambiance and simple yet elegant architecture. These temples attract devotees and visitors seeking quiet spiritual experiences. The calm surroundings, clean premises, and devotional environment make them ideal places for meditation and religious visits."
  },
  {
    "title": "Indapur Market Area",
    "description": "The bustling market area of Indapur offers a glimpse into the town’s daily life and local economy. Visitors can explore shops selling agricultural goods, spices, textiles, traditional sweets, and local snacks. The lively streets, friendly vendors, and authentic rural-town vibe make the market an interesting place to experience local culture."
  },
  {
    "title": "Agricultural Fields and Sugarcane Farms",
    "description": "Indapur is known for its fertile agricultural land, especially sugarcane cultivation supported by canal irrigation from Ujani Dam. Long stretches of green fields, farm roads, and irrigation channels create scenic views ideal for countryside drives and photography. These landscapes highlight the agrarian strength and simplicity of rural Maharashtra."
  },
  {
    "title": "Canal Roads and Irrigation Views",
    "description": "The canal network around Indapur offers unique scenic routes where water flows alongside roads and farmland. These areas are perfect for peaceful drives, cycling, and evening walks. The sound of flowing water combined with open rural surroundings creates a refreshing and relaxing experience away from city noise."
  },
  {
    "title": "Nearby Village Temples",
    "description": "Several small villages around Indapur feature ancient temples dedicated to local deities and forms of Lord Shiva, Hanuman, and Vitthal. These temples are deeply connected to village traditions and festivals. Visiting them provides insight into regional beliefs, folk customs, and strong community bonds."
  },
  {
    "title": "Seasonal Bird Watching Spots",
    "description": "The wetlands and water bodies near Ujani Dam attract various migratory and local bird species, especially during winter. Bird watchers can spot herons, egrets, ducks, and other water birds in their natural habitat. The quiet surroundings make it ideal for nature observation and wildlife photography."
  },
  {
    "title": "Rural Sunset Viewpoints",
    "description": "Open plains and elevated spots around Indapur offer beautiful sunset views with wide horizons and colorful skies. The golden light over fields, canals, and distant hills creates picturesque scenes. These spots are perfect for unwinding in the evening, photography, and enjoying the calm rhythm of rural life."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Indapur",
      "description": "Urbania on Rent in Indapur provides fully air-conditioned Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Each vehicle is well-maintained and driven by professional chauffeurs to ensure a safe, comfortable, and convenient travel experience."
    },
    {
      "name": "Indapur Urbania Bus Hire",
      "description": "Indapur Urbania Bus Hire offers spacious air-conditioned buses for group tours, corporate events, school trips, and social gatherings. Comfortable seating and experienced drivers make every journey reliable, safe, and enjoyable."
    },
    {
      "name": "Urbania Rental Service Indapur",
      "description": "Urbania Rental Service Indapur delivers premium Urbania vehicles suitable for family trips, sightseeing, corporate travel, and leisure outings. Professional chauffeurs ensure convenient, safe, and dependable transportation at all times."
    },
    {
      "name": "Urbania AC Bus on Rent Indapur",
      "description": "Urbania AC Bus on Rent Indapur provides fully air-conditioned buses for long-distance travel, group tours, and corporate outings. Spacious interiors and trained chauffeurs ensure a smooth and comfortable journey."
    },
    {
      "name": "Corporate Urbania Hire Indapur",
      "description": "Corporate Urbania Hire Indapur offers professional transportation services for office trips, employee commutes, and corporate events. Punctual service and experienced chauffeurs ensure smooth, reliable, and professional travel solutions."
    },
    {
      "name": "Urbania for Outstation Indapur",
      "description": "Urbania for Outstation Indapur provides safe and comfortable long-distance travel with air-conditioned vehicles. Experienced drivers make trips to nearby cities, tourist destinations, and corporate locations convenient and enjoyable."
    },
    {
      "name": "Urbania Airport Transfer Indapur",
      "description": "Urbania Airport Transfer Indapur ensures timely pickups and drops for domestic and international airports. Spacious vehicles and professional chauffeurs provide convenient, safe, and stress-free airport transportation."
    },
    {
      "name": "Luxury Urbania Indapur",
      "description": "Luxury Urbania Indapur offers high-end air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs ensure a premium, stylish, and comfortable travel experience."
    },
    {
      "name": "Affordable Urbania Hire Indapur",
      "description": "Affordable Urbania Hire Indapur provides budget-friendly Urbania rental services without compromising on comfort or reliability. Ideal for families, groups, and corporate clients seeking value-for-money travel."
    },
    {
      "name": "Chauffeur Driven Urbania Indapur",
      "description": "Chauffeur Driven Urbania Indapur ensures stress-free travel with trained, verified chauffeurs. Fully air-conditioned vehicles provide smooth, safe, and comfortable journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Indapur",
      "description": "Urbania for Wedding Events Indapur offers elegant air-conditioned vehicles for weddings, guest transport, and family travel. Professional chauffeurs ensure timely, stylish, and hassle-free transportation."
    },
    {
      "name": "Urbania for Office Trips Indapur",
      "description": "Urbania for Office Trips Indapur delivers reliable and comfortable transportation for daily office commutes, team outings, and corporate events. Focused on convenience and punctuality for corporate travel needs."
    },
    {
      "name": "Best Urbania Rental Indapur",
      "description": "Best Urbania Rental Indapur provides top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Suitable for corporate travel, family trips, and group outings requiring premium transportation."
    },
    {
      "name": "Urbania Group Travel Indapur",
      "description": "Urbania Group Travel Indapur offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure safe, convenient, and enjoyable group travel."
    },
    {
      "name": "Reliable Urbania Hire Indapur",
      "description": "Reliable Urbania Hire Indapur provides trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs ensure convenient, comfortable, and dependable travel for all passengers."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Indapur", "Indapur Urbania Bus Hire"],
    ["Urbania Rental Service Indapur", "Urbania AC Bus on Rent Indapur"],
    ["Corporate Urbania Hire Indapur", "Urbania for Outstation Indapur"],
    ["Urbania Airport Transfer Indapur", "Luxury Urbania Indapur"],
    ["Affordable Urbania Hire Indapur", "Chauffeur Driven Urbania Indapur"],
    ["Urbania for Wedding Events Indapur", "Urbania for Office Trips Indapur"],
    ["Best Urbania Rental Indapur", "Urbania Group Travel Indapur"],
    ["Reliable Urbania Hire Indapur", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Indapur",
        "WhyChoosedescription": "Urbania On Rent in Indapur is ideal for group travel, corporate trips, family outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Indapur provides well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Indapur comes with skilled and courteous drivers familiar with Indapur routes, Pune highways, and nearby areas, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Indapur for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Indapur provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Indapur is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Indapur are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Indapur guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Indapur available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Indapur can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Indapur?',
        answer: 'You can book Urbania On Rent in Indapur via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Indapur?',
        answer: 'Urbania On Rent in Indapur offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Indapur are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Indapur allows flexible pickup and drop locations across Indapur, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Indapur available 24x7?',
        answer: 'Yes, Urbania On Rent in Indapur operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Indapur accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Indapur is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vinay Shinde',
        feedback: 'Urbania On Rent in Indapur made our family trip very comfortable and enjoyable. Spacious, clean, and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rekha Patil',
        feedback: 'We hired Urbania On Rent in Indapur for a corporate outing. Excellent service and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rohan Jadhav',
        feedback: 'Urbania On Rent in Indapur provided smooth and hassle-free travel for our group trip. Highly recommended.',
        rating: 5,
    },
];





















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Indapur",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-indapur.jpg",
  "description": "Urbania On Rent in Indapur offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Indapur and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-indapur"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Indapur | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Indapur for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Indapur Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Indapur, Indapur Urbania Bus Hire, Urbania Rental Service Indapur, Urbania AC Bus on Rent Indapur, Corporate Urbania Hire Indapur, Urbania for Outstation Indapur, Urbania Airport Transfer Indapur, Luxury Urbania Indapur, Affordable Urbania Hire Indapur, Chauffeur Driven Urbania Indapur, Urbania for Wedding Events Indapur, Urbania for Office Trips Indapur, Best Urbania Rental Indapur, Urbania Group Travel Indapur, Reliable Urbania Hire Indapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/102.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinindapur;